/*
 * @Description: 
 * @Author: doris_xu
 * @Date: 2025-11-20 14:03:09
 * @LastEditTime: 2025-11-28 14:11:31
 */
// import SubTitle from '../title/sub-title';
import { Steps } from 'antd';
const { Step } = Steps;

const RequireIntro = () => {
    const month = new Date().getMonth() + 1;
    const date = new Date().getDate();
    return (
        <>
            {/* <Banner /> */}
            <div className='jury__line outlineTitle' style={{ textAlign: 'center', marginTop: '128px' }}>
                <label className={`enter_label  active `}>参赛要求</label>
            </div>
            <div className='home-row schedule_time intro' style={{ margin: '44px auto 20px', fontSize: '20px',color: 'rgba(0, 0, 0, .55)' }}>
            <div
                        dangerouslySetInnerHTML={{
                            __html: `
    <p style="text-indent: 24pt;font-size:23px;color:rgba(0, 0, 0, .85);">一、参赛项目要求</p>
    <p style="text-indent: 24pt;">本届“龙知交”大赛以技术领先、市场潜力大、落地转化前景好的本省高价值专利为参赛项目。</p>
    <p style="text-indent: 24pt;">（一）本届大赛参赛项目分为初创组和成长组。其中，高校院所参赛项目列入初创组。参赛企业按2024年汇算清缴的营业收入进行分组，营业收入300万元人民币以下（含）的列入初创组，营业收入300万元人民币以上的列入成长组。</p>
    <p style="text-indent: 24pt;">若参赛主体为多个企业联合参赛或高校院所与企业联合参赛，则按参赛企业的2024年汇算清缴的营业收入总和计算。</p>
    <p style="text-indent: 24pt;">（二）参赛项目应当是具有至少一项核心技术（含基础技术、重要技术分支）的专利。参赛项目拥有多件专利的，应明确其中一件专利为参赛核心专利。</p>
    <p style="text-indent: 24pt;">（三）参赛项目的核心专利应在有效期内，且无知识产权纠纷，《专利转化运用专项行动方案（2023—2025年）》以来形成的专利产业化优先。除参赛核心专利之外，参赛主体应该将与参赛项目关系最密切且能够形成专利组合的不超过10个发明专利、实用新型专利、外观设计专利一起参赛。</p>
    <p style="text-indent: 24pt;">（四）参赛项目所属专利技术领域应以黑龙江省“4567”现代化产业体系为主。</p>
    <p style="text-indent: 24pt;">（五）已获得过国家级、省级专利奖的项目，不得报名参加比赛。</p>
    <p style="text-indent: 24pt;font-size:23px;color:rgba(0, 0, 0, .85);">二、参赛主体（团队）要求</p>
    <p style="text-indent: 24pt;">（一）参赛项目权利人为高校院所的，需经所在单位同意后方可报名。</p>
    <p style="text-indent: 24pt;">（二）参赛团队成员可包括参赛主体在册员工。一经报名，参赛团队成员不可变更，参赛主体成员若发生变更，应报大赛执委会并在“黑龙江科技成果和知识产权交易平台”官网公示后更换。大赛中上场答辩的人员，必须是已报名的参赛团队成员。</p>
    <p style="text-indent: 24pt;">（三）同一企业报名参赛项目不得超过3个，高校院所不受报名数量限制。</p>
    <p style="text-indent: 24pt;font-size:23px;color:rgba(0, 0, 0, .85);">三、报名承诺</p>
    <p style="text-indent: 24pt;">报名方承诺对所填写内容及递交材料的真实性、合法性承担责任。</p>
    <p style="text-indent: 24pt;font-size:23px;color:rgba(0, 0, 0, .85);">四、项目推广</p>
    <p style="text-indent: 24pt;">报名方同意大赛组委会对本项目在大赛官方渠道开展项目推广。</p>
    `,
    // <p style="text-indent: 24pt;font-size:23px;color:rgba(0, 0, 0, .85);">三、奖项设置</p>
    // <p style="text-indent: 24pt;">（一）本届“龙知交赛”设金奖、银奖、专项奖，共31项，奖金总额约20万元。具体奖项设置如下：</p>
    // <p style="text-indent: 24pt;">金奖10项，奖金1万元/项，金奖奖金合计10万元。</p>
    // <p style="text-indent: 24pt;">银奖15项，奖金5000元/项，银奖奖金合计7.5万元。</p>
    // <p style="text-indent: 24pt;">专利许可转让奖（3项)，奖金3000元/项，奖金合计0.9万元。</p>
    // <p style="text-indent: 24pt;">专利作价入股奖（3项)，奖金3000元/项，奖金合计0.9万元。</p>
    // <p style="text-indent: 24pt;">（二）为激励省内各市局对大赛的支持，设立最佳组织奖，金牌导师奖。</p>
                        }}
                    />
            </div>
        </>
    );
};

export default RequireIntro;
